import {
  anIdefenseConfig,
  anUpdateIdefenseThreatIntelSource,
  aThreatIntelSource,
  mockUpdateIdefenseThreatIntelSourceOperationMutation,
  ThreatIntelSourceType,
} from '__generated__';

export const getUpdateIdefenseThreatIntelSourceMutation = ({
  name,
  description,
  apiKey,
}) => {
  return mockUpdateIdefenseThreatIntelSourceOperationMutation(
    (_req, res, ctx) => {
      return res(
        ctx.delay(0), // mock loading state
        ctx.data({
          __typename: 'Mutation',
          updateIdefenseThreatIntelSource: anUpdateIdefenseThreatIntelSource({
            data: aThreatIntelSource({
              id: '1',
              name: name,
              description: description,
              sourceType: ThreatIntelSourceType.Idefense,
              idefenseConfig: anIdefenseConfig({
                __typename: 'IdefenseConfig',
                enabled: true,
                apiKey,
              }),
              items: {
                hasNextPage: false,
                objects: [],
                __typename: 'ThreatIntelItemPage',
                total: 0,
              },
            }),
          }),
        })
      );
    }
  );
};

export const handlers = [
  mockUpdateIdefenseThreatIntelSourceOperationMutation((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Mutation',
        updateIdefenseThreatIntelSource: anUpdateIdefenseThreatIntelSource(),
      })
    );
  }),
];
